import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useInfinityPressroom } from "../../hooks/useCms";
import { useHistory } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";

import moment from "moment";

const ArticleListView = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { subtitle, title, readmore } = content;
  const { entries, pageCount } = useInfinityPressroom();
  const [articles, setArticles] = useState([]);

  const history = useHistory();

  const goToMobileLink = (link, slug) => {
    if (link) {
      window.open(link);
    } else {
      history.push(slugToCountryPathname(slug));
    }
  };

  const goToLink = (link, slug) => {
    return link || slugToCountryPathname(slug);
  };

  useEffect(() => {
    if (entries) {
      setArticles(entries);
    }
  }, [entries, pageCount]);

  const formatApplicationDate = publicationDate => {
    return moment(publicationDate).format("DD MMM YYYY").toUpperCase();
  };

  return (
    <div id="ArticleListView">
      <div className="wrap">
        <div className="subtitle">{subtitle}</div>
        <div className="title">{title}</div>
        {articles.map(({ header: { h1, heroImage }, publicationDate, slug, link }, index) => (
          <div className="articleContainer" key={index} onClick={() => isMobile && goToMobileLink(link, slug)}>
            <div className="photo">
              <img src={heroImage.url} alt="" />
            </div>
            <div className="contentContainer">
              <div className="heading">{h1}</div>
              <div className="date">{formatApplicationDate(publicationDate)}</div>
            </div>
            <div className="readmore">
              <a href={goToLink(link, slug)} target="_blank" rel="noopener noreferrer">
                {readmore}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArticleListView;
